<template>
    <div>
        <CCol sm="12">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
    
                <CCard class="p-2" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="11" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                            <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                                <img :src="activeButton === button.value ? require(`@/assets/img/${button.activeIcon}`) : require(`@/assets/img/${button.inactiveIcon}`)" style="max-width:20px" class="mr-2" /> {{ button.label }}
                            </div>
                        </CCol>
                        <CCol sm="6">
                            <CButton class="btn-border-blue font-color-0B63F6 float-right" @click="openCreate"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Create Announcement</CButton>
                        </CCol>
                        
                    </CRow>
                    <CRow>
                        
                    </CRow>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div v-if="activeButton === 'all'">
                        <CCol sm="12" md="4" lg="2" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="12"><span>filter</span>
                                        <select v-model="perPage" id="entries" class="form-control">
                                                            <option :value="10">10</option>
                                                            <option :value="25">25</option>
                                                            <option :value="50">50</option>
                                                            <option :value="100">100</option>
                                                        </select>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
    
                        <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
                            <template v-slot:No="{ row }">
                                                      <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Title="{ row }">
    <label class="custom-12px-500">{{ row.Title }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Status }}</label>
</template>

<template v-slot:Announcer="{ row }">
    <label class="custom-12px-500">{{ row.Status }}</label>
</template>

<template v-slot:Created Date="{ row }">
    <label class="custom-12px-500">{{ row.CreatedDate }}</label>
</template>

<template v-slot:Updated Date="{ row }">
    <label class="custom-12px-500">{{ row.UpdatedDate }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex"> 
        <img :src="require('@/assets/img/an-eye.png')" alt="View" style="cursor: pointer;width:20px" @click="viewRow(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/an-edit.png')" alt="Print" style="cursor: pointer;width:20px" @click="openEdit(row.Index)"class="ml-2" />
        <img :src="require('@/assets/img/an-trash.png')" alt="View" style="cursor: pointer; width:20px" @click="openDelete(row.Index)" class="ml-2" />
                                                
    </div>
</template>
              </v-client-table>
              <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
    </div>
            </div>


            <div v-if="activeButton === 'unread'">
                        <CCol sm="12" md="4" lg="2" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="12"><span>filter</span>
                                        <select v-model="perPage" id="entries" class="form-control">
                                                            <option :value="10">10</option>
                                                            <option :value="25">25</option>
                                                            <option :value="50">50</option>
                                                            <option :value="100">100</option>
                                                        </select>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
    
                        <v-client-table :data="unreadTableData" :columns="columns" :options="options" class="custom-table" v-if="unreadTableData.length > 0">
                            <template v-slot:No="{ row }">
                                                      <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Title="{ row }">
    <label class="custom-12px-500">{{ row.Title }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Status }}</label>
</template>

<template v-slot:Announcer="{ row }">
    <label class="custom-12px-500">{{ row.Status }}</label>
</template>

<template v-slot:Created Date="{ row }">
    <label class="custom-12px-500">{{ row.CreatedDate }}</label>
</template>

<template v-slot:Updated Date="{ row }">
    <label class="custom-12px-500">{{ row.UpdatedDate }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex"> 
        <img :src="require('@/assets/img/an-eye.png')" alt="View" style="cursor: pointer;width:20px" @click="viewRow(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/an-edit.png')" alt="Print" style="cursor: pointer;width:20px" @click="editStatus(item.Id)"class="ml-2" />
        <img :src="require('@/assets/img/an-trash.png')" alt="View" style="cursor: pointer; width:20px" @click="DeactiveStaff(item.Id)" class="ml-2" />
                                                
    </div>
</template>
              </v-client-table>
              <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
    </div>
            </div>
                   

                </CCard>
            </CCol>
    
        </CCol>
        <div v-if="OpenCreate" class="popup-all backdrop-all">
            <div class="popup-all1">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Create New Announcement</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupCreate" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Title</h3>
                                        <CInput type="text" v-model="FullName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Detail Announcement</h3>
                                        <CTextarea type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Select Department</h3>
                                        <v-select type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="12" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Select Employee</h3>
                                        <v-select type="text" v-model="ShortName" />
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="12" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Upload Attachment</h3>
                                <div class="text-center p-1">
                                    
                                    <CCard>
                                        <div class="text-center">
                                            <br /><br />
                                            <img src="../assets/img/upload1.png" style="max-width:50px;"/>
                                            <img :src="LogoPath" style="max-width:150px" v-if="filePreview == null" />
    
                                            <img :src="filePreview" style="max-width: 100px; cursor: pointer;" @click="triggerFileInput" />
                                            <input type="file" ref="fileInput" @change="onFileChange" style="display: none;" />
                                            <p class="font-color-0B63F6" @click="triggerFileInput">Click to upload or drag and drop </p>
                                            <p class="font-color-98A2B3">SVG, PNG, JPG, or GIF (max. 800x400px)</p>
    
                                            <!-- Display the file name if an image is not uploaded -->
                                            <p v-if="fileName" class="mt-2 mb-5">{{ fileName }}</p>
                                        </div>
    
    
                                    </CCard>
                                </div>
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Submit</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="OpenEdit" class="popup-all backdrop-all">
            <div class="popup-all1">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Edit Announcement</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupEdit" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Title</h3>
                                        <CInput type="text" v-model="FullName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Detail Announcement</h3>
                                        <CTextarea type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Select Department</h3>
                                        <v-select type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="12" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Select Employee</h3>
                                        <v-select type="text" v-model="ShortName" />
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="12" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Upload Attachment</h3>
                                <div class="text-center p-1">
                                    
                                    <CCard>
                                        <div class="text-center">
                                            <br /><br />
                                            <img src="../assets/img/upload1.png" style="max-width:50px;"/>
                                            <img :src="LogoPath" style="max-width:150px" v-if="filePreview == null" />
    
                                            <img :src="filePreview" style="max-width: 100px; cursor: pointer;" @click="triggerFileInput" />
                                            <input type="file" ref="fileInput" @change="onFileChange" style="display: none;" />
                                            <p class="font-color-0B63F6" @click="triggerFileInput">Click to upload or drag and drop </p>
                                            <p class="font-color-98A2B3">SVG, PNG, JPG, or GIF (max. 800x400px)</p>
    
                                            <!-- Display the file name if an image is not uploaded -->
                                            <p v-if="fileName" class="mt-2 mb-5">{{ fileName }}</p>
                                        </div>
    
    
                                    </CCard>
                                </div>
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Submit</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="OpenDelete" class="popup-all backdrop-all">
            <div class="popup-all3">
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12" class="text-center">
                                        <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:20%" @click="openDelete(row.Index)" class="ml-2" />
                                    </CCol>
                                    <CCol sm="12" class="text-center">
                                        <h3 class="custom-14px-500 font-color-171717">Are you sure?</h3>
                                    </CCol>
                                    <CCol sm="12" class="text-center">
                                        <h3 class="custom-14px-500 font-color-171717">Are you sure to delete this announcement?</h3>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow>
                            <div class="text-right ml-2">
                            <CButton class="p-2 text-center bg-#FFFFF text-blue border-radius-half custom-button-padding" style="border-color: blue;" @click="SubmitCompany">
                                Delete</CButton>
                        </div>
                        <div class="text-left ml-5">
                             <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="closePopupDelete">
                                    Cancel</CButton>
                        </div>
                        </CRow>
                        
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import { CTextarea } from "@coreui/vue";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            activeButton: 'all', // Default active button
            buttons: [
                { value: 'all', label: 'All Announcement', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'unread', label: 'Unread Announcement', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],
            columns: [
                'No',
                'Title',
                'Status',
                'Announcer',
                'Created Date',
                'Updated Date',
                'Action'
            ],
            allTableData: [
                { No: 1, Title: 'Tambahan Elaun Parking Time', 'Status': 'New', Announcer: 'Muhammad Raziq Rashid', 'Created Date': '14 May 2024', 'Updated Date': '14 May 2024' },
                { No: 2, Title: 'Perubahan Tetapan ‘ Auto Clock Out’', 'Status': 'New', Announcer: 'Muhammad Raziq Rashid', 'Created Date': '14 May 2024', 'Updated Date': '14 May 2024' },
                { No: 3, Title: 'Cuti Tahunan (Annual Leave)', 'Status': 'New', Announcer: 'Muhammad Raziq Rashid', 'Created Date': '14 May 2024', 'Updated Date': '14 May 2024' }
            ], // Data for the leave table
            unreadTableData: [
                { No: 1, Title: 'Tambahan Elaun Parking Time', 'Status': 'New', Announcer: 'Muhammad Raziq Rashid', 'Created Date': '14 May 2024', 'Updated Date': '14 May 2024' },
                { No: 2, Title: 'Perubahan Tetapan ‘ Auto Clock Out’', 'Status': 'New', Announcer: 'Muhammad Raziq Rashid', 'Created Date': '14 May 2024', 'Updated Date': '14 May 2024' },
                { No: 3, Title: 'Cuti Tahunan (Annual Leave)', 'Status': 'New', Announcer: 'Muhammad Raziq Rashid', 'Created Date': '14 May 2024', 'Updated Date': '14 May 2024' }
            ], // Data for the leave table
            options: {
                perPage: 5,
                pagination: true,
                searchable: true
            },
            isPopupSuccess: false,
            OpenCreate: false,
            OpenEdit: false,
            OpenDelete: false,


        }





    },
    async mounted() {
        //     try {
        //         const isAuth = await this.UserAuth();
        //         if (isAuth) {

        //         } else {
        //             this.GoToPage();
        //             this.$nextTick(() => {
        //   this.setCalendarView();
        // });
        //         }
        //     } catch (error) {
        //         this.GoToPage();
        //         console.error("Error during authentication:", error);
        //         // Handle the error here
        //     }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        openCreate() {
            this.OpenCreate = true;
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.OpenCreate = false;
        },
        closePopupCreate() {
            this.OpenCreate = false;
        },
        openEdit() {
            this.OpenEdit = true;
        },
        closePopupEdit() {
            this.OpenEdit = false;
        },
        openDelete() {
            this.OpenDelete = true;
        },
        closePopupDelete() {
            this.OpenDelete = false;
        },

    }

};
</script>